import { getToken, returnError } from './helperFunc';
import {
	allOutletsAction,
	allOutletsSummaryAction,
	createOutletAction,
	typesLookupAction,
	updateOutletAction,
	allMachinesAction,
	allOutletsOnlineStatusAction,
	updateOutletGroupingAction,
	allOutletsDataOnlyAction,
	allOutletsDataOnlyReportAction,
	fetchOutletsControllerAction,
	allOutletsPingerLogAction,
	fetchControllerv2,
	updateOutletVisibilityActionv2,
	fetchOutletsByRoleAction,
	toggleKillSwitchAction,
	activateOutletAction,
	deactivateOutletAction,
	startMachineTrialAction,
	endMachineTrialAction,
	allOutletsMyOutletsDataOnlyAction,
	allOutletsDataOnlyReportCollectionAction
} from './requestEndpoints';
import { LOGOUT_SUCCESS } from './userReducer';

const SET_OUTLET_LOADING = 'SET_OUTLET_LOADING';
const CLEAR_OUTLET_ERROR = 'CLEAR_OUTLET_ERROR';

const SET_MANAGE_LOADING = 'SET_MANAGE_LOADING';
const CLEAR_MANAGE_ERROR = 'CLEAR_MANAGE_ERROR';

const GET_OUTLET_SUCCESS = 'GET_OUTLET_SUCCESS';
const GET_OUTLET_FAIL = 'GET_OUTLET_FAIL';

const GET_MACHINES_SUCCESS = 'GET_MACHINES_SUCCESS';
const GET_MACHINES_FAIL = 'GET_MACHINES_FAIL';

const CREATE_OUTLET_SUCCESS = 'CREATE_OUTLET_SUCCESS';
const CREATE_OUTLET_FAIL = 'CREATE_OUTLET_FAIL';

const TYPE_LOOKUP_SUCCESS = 'TYPE_LOOKUP_SUCCESS';
const TYPE_LOOKUP_FAIL = 'TYPE_LOOKUP_FAIL';

const UPDATE_OUTLET_SUCCESS = 'UPDATE_OUTLET_SUCCESS';
const UPDATE_OUTLET_FAIL = 'UPDATE_OUTLET_FAIL';

const GET_OUTLETS_ONLINE_SUCCESS = 'GET_OUTLETS_ONLINE_SUCCESS';
const GET_OUTLETS_ONLINE_FAIL = 'GET_OUTLETS_ONLINE_FAIL';

const UPDATE_OUTLET_MACHINE_GROUPING_SUCCESS = 'UPDATE_OUTLET_MACHINE_GROUPING_SUCCESS';
const UPDATE_OUTLET_MACHINE_GROUPING_FAIL = 'UPDATE_OUTLET_MACHINE_GROUPING_FAIL';

const FETCH_OUTLETS_SUCCESS = 'FETCH_OUTLETS_SUCCESS';
const FETCH_OUTLETS_FAIL = 'GET_OUTLET_FAIL';

const FETCH_OUTLETS_SUCCESS_COLLECTION = 'FETCH_OUTLETS_SUCCESS_COLLECTION';
const FETCH_OUTLETS_FAIL_COLLECTION = 'GET_OUTLET_FAIL_COLLECTION';

const FETCH_MANAGE_OUTLET_SUCCESS = 'FETCH_MANAGE_OUTLET_SUCCESS';
const FETCH_MANAGE_OUTLET_FAIL = 'FETCH_MANAGE_OUTLET_FAIL';

const MANAGE_OUTLET_SUCCESS = 'MANAGE_OUTLET_SUCCESS';
const MANAGE_OUTLET_FAIL = 'MANAGE_OUTLET_FAIL';

const FETCH_OUTLETS_BY_ROLE_SUCCESS = 'FETCH_OUTLETS_BY_ROLE_SUCCESS';
const FETCH_OUTLETS_BY_ROLE_FAIL = 'FETCH_OUTLETS_BY_ROLE_FAIL';

const TOGGLE_KILL_SWITCH_SUCCESS = 'TOGGLE_KILL_SWITCH_SUCCESS';
const TOGGLE_KILL_SWITCH_FAIL = 'TOGGLE_KILL_SWITCH_FAIL';

const ACTIVATE_OUTLET_SUCCESS = 'ACTIVATE_OUTLET_SUCCESS';
const ACTIVATE_OUTLET_FAIL = 'ACTIVATE_OUTLET_FAIL';

const DEACTIVATE_OUTLET_SUCCESS = 'DEACTIVATE_OUTLET_SUCCESS';
const DEACTIVATE_OUTLET_FAIL = 'DEACTIVATE_OUTLET_FAIL';

const START_MACHINE_TRIAL_SUCCESS = 'START_MACHINE_TRIAL_SUCCESS';
const START_MACHINE_TRIAL_FAIL = 'START_MACHINE_TRIAL_FAIL';

const END_MACHINE_TRIAL_SUCCESS = 'END_MACHINE_TRIAL_SUCCESS';
const END_MACHINE_TRIAL_FAIL = 'END_MACHINE_TRIAL_FAIL';

const FETCH_MY_OUTLETS_SUCCESS = 'FETCH_MY_OUTLETS_SUCCESS';
const FETCH_MY_OUTLETS_FAIL = 'FETCH_MY_OUTLETS_FAIL';

// FOR OUTLETS
export const fetchAllOutletsDataOnly = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_OUTLET_ERROR });
		dispatch({ type: SET_OUTLET_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await allOutletsDataOnlyAction(operatorId, token);
		// console.log('data', data)
		dispatch({ type: FETCH_OUTLETS_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: FETCH_OUTLETS_FAIL, payload: returnError(error) });
	}
};

// FOR OUTLETS - MY OUTLETS
export const fetchMyOutletsDataOnly = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_OUTLET_ERROR });
		dispatch({ type: SET_OUTLET_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await allOutletsMyOutletsDataOnlyAction(operatorId, token);
		// console.log('data', data)
		dispatch({ type: FETCH_MY_OUTLETS_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: FETCH_MY_OUTLETS_FAIL, payload: returnError(error) });
	}
};

// FOR OUTLETS REPORT
export const fetchAllOutletsDataOnlyReport = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_OUTLET_ERROR });
		dispatch({ type: SET_OUTLET_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await allOutletsDataOnlyReportAction(operatorId, token);
		// console.log('data', data)
		dispatch({ type: FETCH_OUTLETS_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: FETCH_OUTLETS_FAIL, payload: returnError(error) });
	}
};

// FOR OUTLETS REPORT
export const fetchAllOutletsDataOnlyReportCollection = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_OUTLET_ERROR });
		dispatch({ type: SET_OUTLET_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await allOutletsDataOnlyReportCollectionAction(operatorId, token);
		// console.log('data', data)
		dispatch({ type: FETCH_OUTLETS_SUCCESS_COLLECTION, payload: data });
	} catch (error) {
		dispatch({ type: FETCH_OUTLETS_FAIL_COLLECTION, payload: returnError(error) });
	}
};

export const fetchAllOutletsAvailable = (reqBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_OUTLET_ERROR });
		dispatch({ type: SET_OUTLET_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await fetchOutletsControllerAction(reqBody, token);
		// console.log('data', data)
		dispatch({ type: FETCH_OUTLETS_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: FETCH_OUTLETS_FAIL, payload: returnError(error) });
	}
};

export const fetchControllerManage = (reqBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_MANAGE_ERROR });
		dispatch({ type: SET_MANAGE_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await fetchControllerv2(reqBody, token);
		// console.log('data', data)
		dispatch({ type: FETCH_MANAGE_OUTLET_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: FETCH_MANAGE_OUTLET_FAIL, payload: returnError(error) });
	}
};

export const ManageOutletController = (reqBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_MANAGE_ERROR });
		dispatch({ type: SET_MANAGE_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await updateOutletVisibilityActionv2(reqBody, token);
		// console.log('data', data)
		dispatch({ type: MANAGE_OUTLET_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: MANAGE_OUTLET_FAIL, payload: returnError(error) });
	}
};

export const allOutlets = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_OUTLET_ERROR });
		dispatch({ type: SET_OUTLET_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await allOutletsAction(operatorId, token);
		// console.log('data', data)
		dispatch({ type: GET_OUTLET_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: GET_OUTLET_FAIL, payload: returnError(error) });
	}
};

export const allOutletsSummary = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_OUTLET_ERROR });
		dispatch({ type: SET_OUTLET_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await allOutletsSummaryAction(operatorId, token);
		// console.log('data', data)
		dispatch({ type: GET_OUTLET_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: GET_OUTLET_FAIL, payload: returnError(error) });
	}
};

export const allOutletsPingerLog = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_OUTLET_ERROR });
		dispatch({ type: SET_OUTLET_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await allOutletsPingerLogAction(operatorId, token);
		// console.log('data', data)
		dispatch({ type: GET_OUTLET_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: GET_OUTLET_FAIL, payload: returnError(error) });
	}
};

export const fetchOutletsByRole = () => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_OUTLET_ERROR });
		dispatch({ type: SET_OUTLET_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await fetchOutletsByRoleAction(token);
		dispatch({ type: FETCH_OUTLETS_BY_ROLE_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: FETCH_OUTLETS_BY_ROLE_FAIL, payload: returnError(error) });
	}
};

export const toggleKillSwitch = (reqBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_OUTLET_ERROR });
		dispatch({ type: SET_OUTLET_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await toggleKillSwitchAction(reqBody, token);
		dispatch({ type: TOGGLE_KILL_SWITCH_SUCCESS, payload: data });
		return data;
	} catch (error) {
		dispatch({ type: TOGGLE_KILL_SWITCH_FAIL, payload: returnError(error) });
		throw error;
	}
};

export const activateOutlet = (reqBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_OUTLET_ERROR });
		dispatch({ type: SET_OUTLET_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await activateOutletAction(reqBody, token);
		dispatch({ type: ACTIVATE_OUTLET_SUCCESS, payload: data });
		return data;
	} catch (error) {
		dispatch({ type: ACTIVATE_OUTLET_FAIL, payload: returnError(error) });
		throw error;
	}
};

export const deactivateOutlet = (reqBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_OUTLET_ERROR });
		dispatch({ type: SET_OUTLET_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await deactivateOutletAction(reqBody, token);
		dispatch({ type: DEACTIVATE_OUTLET_SUCCESS, payload: data });
		return data;
	} catch (error) {
		dispatch({ type: DEACTIVATE_OUTLET_FAIL, payload: returnError(error) });
		throw error;
	}
};

export const startMachineTrial = (reqBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_OUTLET_ERROR });
		dispatch({ type: SET_OUTLET_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await startMachineTrialAction(reqBody, token);
		dispatch({ type: START_MACHINE_TRIAL_SUCCESS, payload: data });
		return data;
	} catch (error) {
		dispatch({ type: START_MACHINE_TRIAL_FAIL, payload: returnError(error) });
		throw error;
	}
};

export const endMachineTrial = (reqBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_OUTLET_ERROR });
		dispatch({ type: SET_OUTLET_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await endMachineTrialAction(reqBody, token);
		dispatch({ type: END_MACHINE_TRIAL_SUCCESS, payload: data });
		return data;
	} catch (error) {
		dispatch({ type: END_MACHINE_TRIAL_FAIL, payload: returnError(error) });
		throw error;
	}
};

export const getallOutletsOnlineStatus = (reqBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_OUTLET_ERROR });
		dispatch({ type: SET_OUTLET_LOADING });

		const { user } = getState();
		const token = getToken(user);
		// console.log('token', token);
		const { data } = await allOutletsOnlineStatusAction(reqBody, token);
		// console.log('data', data)
		dispatch({ type: GET_OUTLETS_ONLINE_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: GET_OUTLETS_ONLINE_FAIL, payload: returnError(error) });
	}
};

export const allMachines = (operatorId, outletId, coin) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_OUTLET_ERROR });
		dispatch({ type: SET_OUTLET_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await allMachinesAction(operatorId, outletId, coin, token);
		// console.log('data', data);
		dispatch({ type: GET_MACHINES_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: GET_MACHINES_FAIL, payload: returnError(error) });
	}
};

export const createOutlet = (outlet) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_OUTLET_ERROR });
		dispatch({ type: SET_OUTLET_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await createOutletAction(outlet, token);

		dispatch({ type: CREATE_OUTLET_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CREATE_OUTLET_FAIL, payload: returnError(error) });
	}
};

export const updateOutlet = (reqBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_OUTLET_ERROR });
		dispatch({ type: SET_OUTLET_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await updateOutletAction(reqBody, token);

		dispatch({ type: UPDATE_OUTLET_SUCCESS, payload: data });
	} catch (error) {
		const errPayload = returnError(error);
		dispatch({ type: UPDATE_OUTLET_FAIL, payload: errPayload });
		return { error: errPayload };
	}
};

export const updateOutletMachineGrouping = (reqBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_OUTLET_ERROR });
		dispatch({ type: SET_OUTLET_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await updateOutletGroupingAction(reqBody, token);

		dispatch({ type: UPDATE_OUTLET_MACHINE_GROUPING_SUCCESS, payload: data });
	} catch (error) {
		dispatch({
			type: UPDATE_OUTLET_MACHINE_GROUPING_FAIL,
			payload: returnError(error),
		});
	}
};

// MACHINE TEMPLATE LOOKUP
export const typesLookup = () => async (dispatch) => {
	try {
		dispatch({ type: CLEAR_OUTLET_ERROR });
		dispatch({ type: SET_OUTLET_LOADING });

		const { data } = await typesLookupAction();

		dispatch({ type: TYPE_LOOKUP_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: TYPE_LOOKUP_FAIL, payload: returnError(error) });
	}
};

const initialState = {
	language: 'en',
	operator: null,
	error: null,
	loading: false,
	outlets: [],
	newOutlet: null,
	types: [],
	machines: [],
	killSwitchOutlets: [],
	myOutlets: [],
};

export const outletReducer = function (state = initialState, action) {
	switch (action.type) {
		// this is for fetching loading time setter
		case SET_OUTLET_LOADING:
			return {
				...state,
				loading: true,
				error: null,
			};

		case CLEAR_OUTLET_ERROR:
			return {
				...state,
				error: null,
			};

		case SET_MANAGE_LOADING:
			return {
				...state,
				loading: true,
				error: null,
			};

		case CLEAR_MANAGE_ERROR:
			return {
				...state,
				error: null,
			};

		case GET_MACHINES_SUCCESS:
			return {
				...state,
				machines: action.payload.data,
				loading: false,
				error: null,
			};

		case GET_OUTLET_SUCCESS:
		case FETCH_OUTLETS_SUCCESS:
			return {
				...state,
				outlets: action.payload.data,
				loading: false,
				error: null,
			};
		case FETCH_OUTLETS_SUCCESS_COLLECTION:
			return {
				...state,
				outlets2: action.payload.data,
				loading: false,
				error: null,
			};
		case FETCH_MANAGE_OUTLET_SUCCESS:
			return {
				...state,
				manage: action.payload,
				loading: false,
				error: null,
			};

		case MANAGE_OUTLET_SUCCESS:
			return {
				...state,
				managesuccess: action.payload,
				loading: false,
				error: null,
			};

		case FETCH_OUTLETS_BY_ROLE_SUCCESS:
			return {
				...state,
				killSwitchOutlets: action.payload.data || [],
				loading: false,
				error: null,
			};

		case TOGGLE_KILL_SWITCH_SUCCESS:
		case ACTIVATE_OUTLET_SUCCESS:
		case DEACTIVATE_OUTLET_SUCCESS:
		case START_MACHINE_TRIAL_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
			};

		case CREATE_OUTLET_SUCCESS:
		case UPDATE_OUTLET_SUCCESS:
			return {
				...state,
				newOutlet: action.payload.data,
				loading: false,
				error: null,
			};

		case TYPE_LOOKUP_SUCCESS:
			return {
				...state,
				types: action.payload.data,
				loading: false,
				error: null,
			};

		case GET_OUTLETS_ONLINE_SUCCESS:
			// console.log('action.payload', action.payload);
			return {
				...state,
				outletOnlineStatusData: action.payload.outletData,
				outletOnlineMachineData: action.payload.machineData,
				loading: false,
				error: null,
			};
		case LOGOUT_SUCCESS:
			return initialState;

		case UPDATE_OUTLET_MACHINE_GROUPING_SUCCESS:
			return {
				...state,
				outletMachineGrouping: action.payload.outletData,
				loading: false,
				error: null,
			};
		
		case FETCH_MY_OUTLETS_SUCCESS:
			return {
				...state,
				myOutlets: action.payload.data,
				loading: false,
				error: null,
			};

		case FETCH_MY_OUTLETS_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};

		case GET_OUTLET_FAIL:
		case CREATE_OUTLET_FAIL:
		case TYPE_LOOKUP_FAIL:
		case UPDATE_OUTLET_FAIL:
		case GET_MACHINES_FAIL:
		case UPDATE_OUTLET_MACHINE_GROUPING_FAIL:
		case FETCH_MANAGE_OUTLET_FAIL:
		case MANAGE_OUTLET_FAIL:
		case FETCH_OUTLETS_BY_ROLE_FAIL:
		case TOGGLE_KILL_SWITCH_FAIL:
		case ACTIVATE_OUTLET_FAIL:
		case DEACTIVATE_OUTLET_FAIL:
		case START_MACHINE_TRIAL_FAIL:
		case END_MACHINE_TRIAL_FAIL:
			return {
				outlets: state.outlets,
				loading: false,
				error: action.payload,
			};
		case FETCH_OUTLETS_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case FETCH_OUTLETS_FAIL_COLLECTION:
			return {
				...state,
				loading: false,
				error: action.payload,
			};

		default:
			return state;
	}
};
